var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPuzzlePacks = function SvgIconPuzzlePacks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_puzzle_packs_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_puzzle_packs_svg__b",
    width: 19,
    height: 16,
    x: 2,
    y: -2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "m2.628.566 16.918-1.655 1.392 12.491-16.917 1.655z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_puzzle_packs_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M18.917 5.772c.629.478.713 1.357.188 1.962l-5.582 6.437c-.524.606-1.46.709-2.088.23l-1.69-1.286c-.466-.354-.564-.866-.532-1.242.033-.374.195-.745.444-1.033.205-.236.19-.621-.114-.852s-.71-.166-.914.07c-.25.288-.603.512-.987.618-.387.107-.942.122-1.407-.232L4.543 9.156c-.629-.478-.713-1.357-.188-1.962l1.124-1.296c-.997-.858-1.147-2.335-.244-3.377.904-1.042 2.477-1.207 3.578-.469L9.938.757c.524-.605 1.46-.708 2.088-.23l1.691 1.287c.465.354.564.865.532 1.242a1.84 1.84 0 0 1-.444 1.032c-.204.236-.19.621.114.852.304.232.71.166.914-.07.25-.288.603-.512.987-.618.387-.107.941-.121 1.407.233zm-1.653 1.173L16.23 6.16c-.956.961-2.526 1.051-3.583.247-1.058-.805-1.286-2.263-.478-3.336l-1.032-.786-1.035 1.193c-.383.442-.922.557-1.327.538a1.94 1.94 0 0 1-1.097-.4l-.009-.007c-.303-.231-.71-.165-.914.07s-.19.622.114.853l.009.007c.31.228.542.56.643.923.102.368.093.885-.29 1.327L6.196 7.983l1.034.786c.955-.961 2.526-1.051 3.584-.246 1.057.805 1.285 2.263.476 3.336l1.032.785z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M3.413 14.285c.532 0 .963.431.963.963v4.86l6.898 1.896 7.407-1.908v-4.848a.962.962 0 1 1 1.925 0v5.22c0 .66-.446 1.235-1.085 1.4l-7.89 2.032c-.244.063-.5.06-.743-.006l-7.375-2.026a1.445 1.445 0 0 1-1.062-1.393v-5.227c0-.532.43-.963.962-.963",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M1.988 9.778c.531 0 .962.431.962.963v3.19l8.322 1.936 8.845-1.944V11.15a.963.963 0 0 1 1.925 0v3.158c0 .679-.472 1.266-1.135 1.412l-9.327 2.05c-.21.047-.428.045-.638-.003L2.143 15.72a1.445 1.445 0 0 1-1.118-1.407V10.74c0-.532.431-.963.963-.963",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M1.05 10.79a.963.963 0 0 1 1.156-.72l9.066 2.109 9.014-1.982a1.445 1.445 0 0 1 1.755 1.411v1.181a.963.963 0 0 1-1.925 0v-.584l-8.537 1.877c-.21.046-.428.045-.637-.004L1.77 11.946a.96.96 0 0 1-.72-1.156",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    fillRule: "evenodd",
    d: "M4.507 9.755a.96.96 0 0 1-.658 1.191l-1.595.46a.963.963 0 1 1-.533-1.85l1.595-.46a.963.963 0 0 1 1.191.659M22.01 11.119a1.026 1.026 0 0 1-1.284.549l-2.103-.766a.903.903 0 0 1-.536-1.212 1.026 1.026 0 0 1 1.285-.55l2.102.767a.903.903 0 0 1 .536 1.212M11.534 12.248c.531 0 .962.43.962.962v9.037a.962.962 0 1 1-1.925 0V13.21c0-.532.431-.962.963-.962",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_puzzle_packs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPuzzlePacks;